import { keyframes } from 'styled-components';
export const skeletonLoader = keyframes`
  0%{
   background-color: var(--color-light-grey);
  }
  100%{
   background-color: var(--color-grey);
  }
`;
